import React, { FC } from "react";

import { Flair } from "../../../components/Flair";
import { Image } from "../../../components/Image";
import { BreakPoint } from "../../../models/screen";
import { useViewport } from "../../../store/common/hooks";
import { tabFeatureAttributeBlock } from "../elementIDs";
import {
    ITabFeatureAttributeBlock_AttributeTab,
    ITabFeatureAttributeBlock_ModelTab,
} from "../models";

import styles from "./index.module.scss";

type TabFeatureAttributeBlockModelTabImageProps = {
    attrIdx: number;
    attrTab: ITabFeatureAttributeBlock_AttributeTab;
    modelIdx: number;
    modelTab: ITabFeatureAttributeBlock_ModelTab;
    isSelected: boolean;
};

export const TabFeatureAttributeBlockModelTabImage: FC<
    TabFeatureAttributeBlockModelTabImageProps
> = ({ attrIdx, attrTab, modelIdx, modelTab, isSelected }) => {
    const viewport = useViewport();
    const image =
        viewport.width <= BreakPoint.SMALL && modelTab.image_mobile
            ? modelTab.image_mobile
            : modelTab.image;

    return (
        <article
            id={tabFeatureAttributeBlock.modelTabContent(
                attrTab,
                attrIdx,
                modelTab,
                modelIdx,
            )}
            role="tabpanel"
            aria-labelledby={tabFeatureAttributeBlock.modelTabButton(
                attrTab,
                attrIdx,
                modelTab,
                modelIdx,
            )}
            hidden={!isSelected}
        >
            {modelTab.flair?.content && (
                <div className={styles.flair}>
                    <Flair flair={modelTab.flair} inline={true} />
                </div>
            )}
            <div className={styles.image}>
                <Image
                    src={image.url}
                    alt={image.title ?? ""}
                    className="responsive-img"
                />
            </div>
        </article>
    );
};
